// extracted by mini-css-extract-plugin
export default {"taxFeeContainer":"Cxeyr"};